/*jshint esversion: 6 */
var host = '';
if (process.env.NODE_ENV === 'production') {
  host = window.location.hostname;
} else {
  host = 'www.polstargps.com';
}
export function getDataUrl(objin) {
  var obj = objin || {
    api: 'get_device',
    account_id: localStorage.getItem('accountid'),
    output: 'json'
  };
  var url = 'http://' + host + '/WEBAPI/MTX?',
    // var url = 'http://www.polstargps.com/WEBAPI/MTX?',
    strOption = Object.keys(obj).map(function (key) {
      return key + '=' + obj[key];
    }).join('&');

  url = url + strOption + '&_=' + Math.random();
  return url;
}

export function getSendMailUrl(namePHPFile, objin) {
  var obj = objin || {
    email: localStorage.getItem('accountid')
  };
  var url = './mail/' + namePHPFile + '?',
    strOption = Object.keys(obj).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
    }).join('&');

  url = url + strOption;
  return url;
}



// WEBPACK FOOTER //
// ./src/tools/getUrl.js